import { render, staticRenderFns } from "./YA_AlternativesProgress.vue?vue&type=template&id=3cb806ca&scoped=true"
import script from "./YA_AlternativesProgress.vue?vue&type=script&lang=js"
export * from "./YA_AlternativesProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb806ca",
  null
  
)

export default component.exports